import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { useAuth } from '../../providers/AuthProvider'
import { config } from '../../config.js'
import { CenteredFlexColumn } from '../styles/Containers.js'
import BodyText, { BoldSpan } from '../styles/Text.js'
import ActionRequiredTemplate from '../common/ActionRequiredTemplate.js'

const IdContainer = styled(CenteredFlexColumn)`
  gap: 0;
`

function BillRejectEstimateConfirmation({ foiSecondaryId, billSecondaryId }) {
  const { authState } = useAuth()
  const showLogo = !authState.accessToken
  const privacyTeamEmail = config.foi.privacyTeamEmail

  return (
    <ActionRequiredTemplate title="Contact city to amend scope" showLogo={showLogo}>
      <BodyText>
        <BoldSpan>Action required.</BoldSpan> Your estimate <BoldSpan>{foiSecondaryId}</BoldSpan> has been rejected. To amend the scope of your
        request, please contact <BoldSpan>{privacyTeamEmail}</BoldSpan> and include the following information in your email:
      </BodyText>
      <IdContainer>
        <BodyText>
          Request ID: <BoldSpan>{foiSecondaryId}</BoldSpan>
        </BodyText>
        <BodyText>
          Estimate ID: <BoldSpan>{billSecondaryId}</BoldSpan>
        </BodyText>
      </IdContainer>
    </ActionRequiredTemplate>
  )
}

BillRejectEstimateConfirmation.propTypes = {
  foiSecondaryId: PropTypes.string.isRequired,
  billSecondaryId: PropTypes.string.isRequired
}

export default BillRejectEstimateConfirmation
